
	// import { pprint } from '@/helpers/pprint';
	import { defineComponent, onMounted, ref } from "vue";

  interface SelectItem {
    label : any,
    value : any
  }
	export default defineComponent({
		name: "SelectForm",
		components: {},
		props: {
			label: String,
			items: {
				type: Array,
				default: () => [] as string[] | SelectItem[],
			},
			modelValue: String,
		},
		setup(props, { emit }) {
			const radios = ref<HTMLElement | null>(null);
			onMounted(() => {
				radios.value?.querySelectorAll("input").forEach((c) => {
					if (c.innerHTML === props.modelValue) {
						c.checked = true;
					}
				});
			});

			function onSelectRadioItem(ev: Event) {
        let i: number = parseInt((ev.target as HTMLInputElement).value);
				emit("update:modelValue", getValue(props.items[i] as any));
			}

      const id = Math.random();
      
      function getLabel(item : SelectItem | string) {
        if (typeof item === 'string')
          return item
        return item.label
      }
      function getValue(item : SelectItem | string) {
        if (typeof item === 'string')
          return item
        return item.value
      }
			return {
				onSelectRadioItem,
        id,
        getLabel,
        getValue,
			};
		},
	});
